import { type FC, useState } from "react";
import { useRouter } from "next/router";
import Button from "@/components/ui/design-system/Button";
import { server } from "../../state";
import { useMemberInviteModal } from "../account/Modals/MemberInviteModal";
import { auth, getCurrentUser } from "../../state/server";
import { useSwitchSampleDocumentsModal } from "../onboarding/SwitchSampleDocumentsModal";
import Dropdown from "./design-system/Dropdown";
import { AccountCircle, Add, GearFilled, Logout } from "./icons";
import { OnboardingDocument } from "./onboarding/icons";

const AccountDropdown: FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const router = useRouter();
  const account = server.useAccount();
  const user = getCurrentUser(account);
  const { show: showModal } = useSwitchSampleDocumentsModal();
  const initials = `${user?.first_name?.slice(0, 1) ?? ""}${
    user?.last_name?.slice(0, 1) ?? ""
  }`;
  const name =
    user?.first_name && user?.last_name
      ? `${user.first_name} ${user.last_name}`
      : (auth.user ?? "");
  // const { show: showModal } = useSwitchSampleDocumentsModal();

  const { show: showInviteModal } = useMemberInviteModal();

  const UserAvatar = (
    <div
      className={
        "flex flex-shrink-0 items-center justify-center rounded-full bg-yellow-600 text-white font-semibold text-sm p-2"
      }
    >
      {initials}
    </div>
  );

  const UserProfileInfo = (
    <div className={"flex items-center gap-2 !text-black w-full"}>
      {UserAvatar}
      <div className={"w-full flex flex-col"}>
        <p>{name}</p>
        <p className="text-gray-400 pr-8 overflow-hidden text-ellipsis text-sm">
          {user?.email}
        </p>
        <p>{account?.name}</p>
      </div>
    </div>
  );

  return (
    <Dropdown
      isOpen={isOpen}
      role={"account-dropdown"}
      optionsClassName={"!py-ds-4 border-b border-gray-200"}
      optionsContainerClassName={"!max-h-fit"}
      options={[
        {
          label: "",
          render: () =>
            auth.legacyToken ? (
              <div>
                <p className="text-black">{account?.name}</p>
                <p>Legacy Account</p>
              </div>
            ) : (
              UserProfileInfo
            ),
          value: "",
          disabled: true,
        },
        ...(auth.admin
          ? [
              {
                label: "",
                value: "invite",
                onClick: showInviteModal,
                render: () => (
                  <span className={"flex items-center gap-4"}>
                    <Add className={"text-gray-400 w-6"} /> Invite members
                  </span>
                ),
              },
            ]
          : []),
        ...(auth.legacyToken
          ? []
          : [
              {
                label: "",
                value: "profile",
                onClick: () => router.push("/account/profile"),
                render: () => (
                  <span className={"flex items-center gap-4"}>
                    <AccountCircle className={"text-gray-400 w-6"} /> My profile
                  </span>
                ),
              },
            ]),
        {
          value: "account",
          label: "",
          onClick: () => router.push("/account"),
          render: () => (
            <span className={"flex items-center gap-4"}>
              <GearFilled className={"text-gray-400 w-6"} /> Account settings
            </span>
          ),
        },
        {
          value: "sample-documents",
          label: `Try sample documents`,
          onClick: () => {
            showModal();
            setIsOpen(false);
          },
          render: () => (
            <div className={"flex items-center"}>
              <OnboardingDocument className="mr-2 text-gray-400" /> Try sample
              documents
            </div>
          ),
        },
        {
          value: "logout",
          label: ``,
          onClick: () => server.signOut(),
          render: () => (
            <div className={"flex items-center gap-4"}>
              <Logout className={"text-gray-400 w-6"} /> Sign out
            </div>
          ),
        },
      ]}
      onSelect={() => setIsOpen(false)}
      onClickOutside={() => setIsOpen(false)}
      trigger={
        <Button
          variant={"icon_only"}
          type="button"
          onClick={() => setIsOpen((value) => !value)}
          className={"p-1 cursor-pointer"}
        >
          {initials !== "" ? (
            UserAvatar
          ) : (
            <AccountCircle className={"text-gray-400"} />
          )}
        </Button>
      }
    />
  );
};

export default AccountDropdown;
